import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { supabase } from "@/integrations/supabase/client";
import { Logo, PAGE_CONTAINER } from "../components/site";

export const Route = createFileRoute("/wachtwoord-instellen")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Wachtwoord instellen | offerto" },
      { name: "description", content: "Stel veilig het wachtwoord voor je offerto-klantaccount in." },
      { property: "og:title", content: "Wachtwoord instellen | offerto" },
      { property: "og:description", content: "Stel veilig het wachtwoord voor je offerto-klantaccount in." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: WachtwoordPagina,
});

function WachtwoordPagina() {
  const navigate = useNavigate();
  const [wachtwoord, setWachtwoord] = useState("");
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState("");

  async function onOpslaan(e: React.FormEvent) {
    e.preventDefault();
    if (wachtwoord.length < 8) {
      setFout("Kies een wachtwoord van minstens 8 tekens.");
      return;
    }
    setBezig(true);
    setFout("");
    const { error } = await supabase.auth.updateUser({ password: wachtwoord });
    setBezig(false);
    if (error) {
      setFout("Instellen mislukt. Vraag een nieuwe link aan vanaf de inlogpagina.");
      return;
    }
    void navigate({ to: "/mijn-aanvragen" });
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border">
        <div className={`${PAGE_CONTAINER} py-5`}>
          <Logo />
        </div>
      </header>
      <div className="mx-auto w-full max-w-md px-4 py-16">
        <h1 className="mt-8 text-2xl font-extrabold">Stel je wachtwoord in</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Daarna zie je in je account alle aanvragen en documenten die je hebt aangeleverd.
        </p>
        <form onSubmit={onOpslaan} className="mt-6 space-y-4">
          <div>
            <label htmlFor="nieuw-wachtwoord" className="block text-sm font-bold">
              Nieuw wachtwoord
            </label>
            <input
              id="nieuw-wachtwoord"
              type="password"
              value={wachtwoord}
              onChange={(e) => setWachtwoord(e.target.value)}
              autoComplete="new-password"
              className="mt-2 h-11 w-full rounded-lg border border-input bg-background px-3 text-sm outline-none focus:border-primary"
            />
          </div>
          {fout !== "" && <p className="text-sm font-medium text-destructive">{fout}</p>}
          <button
            type="submit"
            disabled={bezig}
            className="h-11 w-full rounded-lg bg-accent px-5 text-sm font-bold text-accent-foreground disabled:opacity-60"
          >
            {bezig ? "Bezig…" : "Wachtwoord opslaan"}
          </button>
        </form>
      </div>
    </div>
  );
}
